module.exports = __webpack_public_path__ + "img/1.36dd6987.png";